const mimeTypes = [
  "text/csv", "application/csv", "text/x-csv", "application/x-csv", "text/x-comma-separated-values", "text/comma-separated-values"
];

export function validate(file) {
  const ext = file.name.split(".").pop();
  if (file.type === "application/vnd.ms-excel" && ext === "csv") {
    return true;
  }
  if (file.type === "" && ext === "csv") {
    return true;
  }
  if (mimeTypes.indexOf(file.type) >= 0) {
    return true;
  }
  return false;
}

export function getUploadMimeType() {
  return "text/csv";
}